import {Component, computed, model, output, signal} from '@angular/core';
import {FermetureJourSemaineDTO} from '../../../core/dtos/client/fermeture/fermeture-jour-semaine-dto';
import {ButtonThemeEnum} from '../../../shared/ui/button/button-theme-enum';

@Component({
  selector: 'yo-fermeture-preview-jour',
  templateUrl: './fermeture-preview-jour.component.html',
  styleUrls: ['./fermeture-preview-jour.component.scss'],
  standalone: false
})
export class FermeturePreviewJourComponent {

  protected readonly ButtonThemeEnum = ButtonThemeEnum;

  visible = model(false);
  pendingLines = model<FermetureJourSemaineDTO[]>([]);

  save = output();

  protected readonly indexedLines = computed(() =>
    this.pendingLines().map((l, i) => ({...l, _idx: i})));

  selectedKeys = signal<number[]>([]);

  onSelectionChanged(e: {selectedRowKeys: number[]}): void {
    this.selectedKeys.set(e.selectedRowKeys);
  }

  deleteSelected(): void {
    const idxSet = new Set(this.selectedKeys());
    this.pendingLines.update(lines => lines.filter((_, i) => !idxSet.has(i)));
    this.selectedKeys.set([]);
  }
}
